import {useEffect, useRef, useState} from 'react'
import {CountingAPI} from '../../apis/CountingAPI'

export const useFilters = (countingId, onFilterChange, {loadCategories = true, loadTesters = true} = {}) => {
    const [filters, setFilters] = useState({})
    const [devices, setDevices] = useState([])
    const [users, setUsers] = useState([])
    const [categories, setCategories] = useState([])
    const [testers, setTesters] = useState([])

    useEffect(() => {
        getUsers()
        getDevices()
        if (loadCategories) getCategories()
        if (loadTesters) getTesters()
    }, [])

    const onFilterChangeRef = useRef(onFilterChange)
    const notifiedFiltersRef = useRef(filters)

    useEffect(() => {
        onFilterChangeRef.current = onFilterChange
    }, [onFilterChange])

    useEffect(() => {
        // Mounting a filter form is not a filter change (including effect replay).
        if (notifiedFiltersRef.current === filters) return
        notifiedFiltersRef.current = filters
        onFilterChangeRef.current(filters)
    }, [filters])

    const handleInputChange = (type, value, match = 'partialy') => {
        const filterValue = value ? (match === 'exact' ? value : `%${value}%`) : undefined
        // Consumers merge filters, so undefined explicitly clears an existing filter.
        setFilters(prevFilters => ({...prevFilters, [type]: filterValue}))
    }

    const handleExactMatchChange = (type, isChecked) => {
        setFilters(prevFilters => {
            if (!prevFilters[type]) return prevFilters
            const value = prevFilters[type].replace(/%/g, '')
            return {...prevFilters, [type]: isChecked ? value : `%${value}%`}
        })
    }

    const computeFilterValue = (type, value) => {
        let filterValue = value || undefined

        switch (type) {
            case 'user_id':
                return users.find(user => `${user.name} ${user.last_name}` === value)?._id
            case 'with_deleted':
            case 'device_number':
            case 'category_row_id':
            case 'category_group':
            case 'custom_row_name':
            case 'category_name':
            case 'tester_id':
                return filterValue
            case 'is_manual':
                return value === 'No' ? false : (value === 'Yes' ? true : undefined)
            default:
                return value === 'No' ? true : value === 'Yes' ? false : undefined
        }
    }

    const handleSelectChange = (type, value) => {
        const filterValue = computeFilterValue(type, value)

        setFilters(prevFilters => ({...prevFilters, [type]: filterValue}))
    }



    const getUsers = async () =>{
        const resp = await CountingAPI.getUsers(countingId)
        // console.log('getUsers', resp)
        setUsers(resp.users)
    }

    const getDevices = async () =>{
        const resp = await CountingAPI.getDevices(countingId)
        // console.log('getDevices', resp)
        setDevices(resp.devices)
    }

    const getCategories = async () =>{
        const resp = await CountingAPI.getCategoryRows(countingId)
        // console.log('getCategoryRows', resp)
        setCategories(resp.category_rows)
    }

    const getTesters = async () =>{
        const resp = await CountingAPI.getCounting(countingId)
        // console.log('getTesters', resp)
        setTesters(resp.counting.testers)
    }
    return {handleInputChange, handleExactMatchChange, handleSelectChange, filters, users, devices, categories, testers}
}